import type { TRect } from '../../types/misc';
import type { SpringValue } from '@react-spring/web';

export interface TOverlayLocations {
  x: number;
  y: number;
  height: number;
  width: number;

  frameLeftX: number;
  frameLeftY: number;
  frameLeftHeight: number;
  frameLeftWidth: number;

  frameRightX: number;
  frameRightY: number;
  frameRightHeight: number;
  frameRightWidth: number;

  frameTopX: number;
  frameTopY: number;
  frameTopHeight: number;
  frameTopWidth: number;

  frameBottomX: number;
  frameBottomY: number;
  frameBottomHeight: number;
  frameBottomWidth: number;

  handleNwX: number;
  handleNwY: number;
  handleNwHeight: number;
  handleNwWidth: number;
  handlePaddedNwX: number;
  handlePaddedNwY: number;
  handlePaddedNwHeight: number;
  handlePaddedNwWidth: number;

  handleSwX: number;
  handleSwY: number;
  handleSwHeight: number;
  handleSwWidth: number;
  handlePaddedSwX: number;
  handlePaddedSwY: number;
  handlePaddedSwHeight: number;
  handlePaddedSwWidth: number;

  handleWX: number;
  handleWY: number;
  handleWHeight: number;
  handleWWidth: number;
  handlePaddedWX: number;
  handlePaddedWY: number;
  handlePaddedWHeight: number;
  handlePaddedWWidth: number;

  handleNeX: number;
  handleNeY: number;
  handleNeHeight: number;
  handleNeWidth: number;
  handlePaddedNeX: number;
  handlePaddedNeY: number;
  handlePaddedNeHeight: number;
  handlePaddedNeWidth: number;

  handleSeX: number;
  handleSeY: number;
  handleSeHeight: number;
  handleSeWidth: number;
  handlePaddedSeX: number;
  handlePaddedSeY: number;
  handlePaddedSeHeight: number;
  handlePaddedSeWidth: number;

  handleEX: number;
  handleEY: number;
  handleEHeight: number;
  handleEWidth: number;
  handlePaddedEX: number;
  handlePaddedEY: number;
  handlePaddedEHeight: number;
  handlePaddedEWidth: number;

  handleSX: number;
  handleSY: number;
  handleSHeight: number;
  handleSWidth: number;
  handlePaddedSX: number;
  handlePaddedSY: number;
  handlePaddedSHeight: number;
  handlePaddedSWidth: number;

  handleNX: number;
  handleNY: number;
  handleNHeight: number;
  handleNWidth: number;
  handlePaddedNX: number;
  handlePaddedNY: number;
  handlePaddedNHeight: number;
  handlePaddedNWidth: number;

  handleInnerX: number;
  handleInnerY: number;
  handleInnerHeight: number;
  handleInnerWidth: number;
  handlePaddedInnerX: number;
  handlePaddedInnerY: number;
  handlePaddedInnerHeight: number;
  handlePaddedInnerWidth: number;

  handleDragShieldX: number;
  handleDragShieldY: number;
  handleDragShieldHeight: number;
  handleDragShieldWidth: number;
}

export interface TSprungOverlayLocations {
  x: SpringValue<number>;
  y: SpringValue<number>;
  height: SpringValue<number>;
  width: SpringValue<number>;

  frameLeftX: SpringValue<number>;
  frameLeftY: SpringValue<number>;
  frameLeftHeight: SpringValue<number>;
  frameLeftWidth: SpringValue<number>;

  frameRightX: SpringValue<number>;
  frameRightY: SpringValue<number>;
  frameRightHeight: SpringValue<number>;
  frameRightWidth: SpringValue<number>;

  frameTopX: SpringValue<number>;
  frameTopY: SpringValue<number>;
  frameTopHeight: SpringValue<number>;
  frameTopWidth: SpringValue<number>;

  frameBottomX: SpringValue<number>;
  frameBottomY: SpringValue<number>;
  frameBottomHeight: SpringValue<number>;
  frameBottomWidth: SpringValue<number>;

  handleNwX: SpringValue<number>;
  handleNwY: SpringValue<number>;
  handleNwHeight: SpringValue<number>;
  handleNwWidth: SpringValue<number>;
  handlePaddedNwX: SpringValue<number>;
  handlePaddedNwY: SpringValue<number>;
  handlePaddedNwHeight: SpringValue<number>;
  handlePaddedNwWidth: SpringValue<number>;

  handleSwX: SpringValue<number>;
  handleSwY: SpringValue<number>;
  handleSwHeight: SpringValue<number>;
  handleSwWidth: SpringValue<number>;
  handlePaddedSwX: SpringValue<number>;
  handlePaddedSwY: SpringValue<number>;
  handlePaddedSwHeight: SpringValue<number>;
  handlePaddedSwWidth: SpringValue<number>;

  handleWX: SpringValue<number>;
  handleWY: SpringValue<number>;
  handleWHeight: SpringValue<number>;
  handleWWidth: SpringValue<number>;
  handlePaddedWX: SpringValue<number>;
  handlePaddedWY: SpringValue<number>;
  handlePaddedWHeight: SpringValue<number>;
  handlePaddedWWidth: SpringValue<number>;

  handleNeX: SpringValue<number>;
  handleNeY: SpringValue<number>;
  handleNeHeight: SpringValue<number>;
  handleNeWidth: SpringValue<number>;
  handlePaddedNeX: SpringValue<number>;
  handlePaddedNeY: SpringValue<number>;
  handlePaddedNeHeight: SpringValue<number>;
  handlePaddedNeWidth: SpringValue<number>;

  handleSeX: SpringValue<number>;
  handleSeY: SpringValue<number>;
  handleSeHeight: SpringValue<number>;
  handleSeWidth: SpringValue<number>;
  handlePaddedSeX: SpringValue<number>;
  handlePaddedSeY: SpringValue<number>;
  handlePaddedSeHeight: SpringValue<number>;
  handlePaddedSeWidth: SpringValue<number>;

  handleEX: SpringValue<number>;
  handleEY: SpringValue<number>;
  handleEHeight: SpringValue<number>;
  handleEWidth: SpringValue<number>;
  handlePaddedEX: SpringValue<number>;
  handlePaddedEY: SpringValue<number>;
  handlePaddedEHeight: SpringValue<number>;
  handlePaddedEWidth: SpringValue<number>;

  handleSX: SpringValue<number>;
  handleSY: SpringValue<number>;
  handleSHeight: SpringValue<number>;
  handleSWidth: SpringValue<number>;
  handlePaddedSX: SpringValue<number>;
  handlePaddedSY: SpringValue<number>;
  handlePaddedSHeight: SpringValue<number>;
  handlePaddedSWidth: SpringValue<number>;

  handleNX: SpringValue<number>;
  handleNY: SpringValue<number>;
  handleNHeight: SpringValue<number>;
  handleNWidth: SpringValue<number>;
  handlePaddedNX: SpringValue<number>;
  handlePaddedNY: SpringValue<number>;
  handlePaddedNHeight: SpringValue<number>;
  handlePaddedNWidth: SpringValue<number>;

  handleInnerX: SpringValue<number>;
  handleInnerY: SpringValue<number>;
  handleInnerHeight: SpringValue<number>;
  handleInnerWidth: SpringValue<number>;
  handlePaddedInnerX: SpringValue<number>;
  handlePaddedInnerY: SpringValue<number>;
  handlePaddedInnerHeight: SpringValue<number>;
  handlePaddedInnerWidth: SpringValue<number>;

  handleDragShieldX: SpringValue<number>;
  handleDragShieldY: SpringValue<number>;
  handleDragShieldHeight: SpringValue<number>;
  handleDragShieldWidth: SpringValue<number>;
}

export const INNER_HANDLE_HEIGHT = 28;
export const INNER_HANDLE_WIDTH = 28;
export const INNER_HANDLE_PADDING = 0;

export const OUTER_HANDLE_HEIGHT = 6;
export const OUTER_HANDLE_WIDTH = 6;
export const OUTER_HANDLE_PADDING = 10;

export const FRAME_WIDTH = 2;

const calculators = {
  handlePaddedX: (x: number, padding: number) => x - padding,
  handlePaddedY: (y: number, padding: number) => y - padding,
  handlePaddedHeight: (height: number, padding: number) => height + padding * 2,
  handlePaddedWidth: (width: number, padding: number) => width + padding * 2,

  handleNwX: (containerLocation: TRect) =>
    containerLocation.x - (OUTER_HANDLE_WIDTH - 1),
  handleNwY: (containerLocation: TRect) =>
    containerLocation.y - (OUTER_HANDLE_HEIGHT - 1),

  handleSwX: (containerLocation: TRect) =>
    containerLocation.x - (OUTER_HANDLE_WIDTH - 1),
  handleSwY: (containerLocation: TRect) =>
    containerLocation.y + containerLocation.height - 1,

  handleWX: (containerLocation: TRect) =>
    containerLocation.x - (OUTER_HANDLE_WIDTH - 1),
  handleWY: (containerLocation: TRect) =>
    containerLocation.y +
    containerLocation.height / 2 -
    OUTER_HANDLE_HEIGHT / 2,

  handleNeX: (containerLocation: TRect) =>
    containerLocation.x + containerLocation.width - 1,
  handleNeY: (containerLocation: TRect) =>
    containerLocation.y - (OUTER_HANDLE_HEIGHT - 1),

  handleSeX: (containerLocation: TRect) =>
    containerLocation.x + containerLocation.width - 1,
  handleSeY: (containerLocation: TRect) =>
    containerLocation.y + containerLocation.height - 1,

  handleEX: (containerLocation: TRect) =>
    containerLocation.x + containerLocation.width - 1,
  handleEY: (containerLocation: TRect) =>
    containerLocation.y +
    containerLocation.height / 2 -
    OUTER_HANDLE_HEIGHT / 2,

  handleSX: (containerLocation: TRect) =>
    containerLocation.x + containerLocation.width / 2 - OUTER_HANDLE_WIDTH / 2,
  handleSY: (containerLocation: TRect) =>
    containerLocation.y + containerLocation.height - 1,

  handleNX: (containerLocation: TRect) =>
    containerLocation.x + containerLocation.width / 2 - OUTER_HANDLE_WIDTH / 2,
  handleNY: (containerLocation: TRect) =>
    containerLocation.y - (OUTER_HANDLE_HEIGHT - 1),

  handleInnerX: (containerLocation: TRect) =>
    containerLocation.x + containerLocation.width / 2 - INNER_HANDLE_WIDTH / 2,
  handleInnerY: (containerLocation: TRect) =>
    containerLocation.y + containerLocation.height / 2 - INNER_HANDLE_HEIGHT / 2
};

const defaultLocations = {
  x: 0,
  y: 0,
  height: 0,
  width: 0,

  frameLeftX: 0,
  frameLeftY: 0,
  frameLeftHeight: 0,
  frameLeftWidth: 0,

  frameRightX: 0,
  frameRightY: 0,
  frameRightHeight: 0,
  frameRightWidth: 0,

  frameTopX: 0,
  frameTopY: 0,
  frameTopHeight: 0,
  frameTopWidth: 0,

  frameBottomX: 0,
  frameBottomY: 0,
  frameBottomHeight: 0,
  frameBottomWidth: 0,

  handleNwX: 0,
  handleNwY: 0,
  handleNwHeight: 0,
  handleNwWidth: 0,
  handlePaddedNwX: 0,
  handlePaddedNwY: 0,
  handlePaddedNwHeight: 0,
  handlePaddedNwWidth: 0,

  handleSwX: 0,
  handleSwY: 0,
  handleSwHeight: 0,
  handleSwWidth: 0,
  handlePaddedSwX: 0,
  handlePaddedSwY: 0,
  handlePaddedSwHeight: 0,
  handlePaddedSwWidth: 0,

  handleWX: 0,
  handleWY: 0,
  handleWHeight: 0,
  handleWWidth: 0,
  handlePaddedWX: 0,
  handlePaddedWY: 0,
  handlePaddedWHeight: 0,
  handlePaddedWWidth: 0,

  handleNeX: 0,
  handleNeY: 0,
  handleNeHeight: 0,
  handleNeWidth: 0,
  handlePaddedNeX: 0,
  handlePaddedNeY: 0,
  handlePaddedNeHeight: 0,
  handlePaddedNeWidth: 0,

  handleSeX: 0,
  handleSeY: 0,
  handleSeHeight: 0,
  handleSeWidth: 0,
  handlePaddedSeX: 0,
  handlePaddedSeY: 0,
  handlePaddedSeHeight: 0,
  handlePaddedSeWidth: 0,

  handleEX: 0,
  handleEY: 0,
  handleEHeight: 0,
  handleEWidth: 0,
  handlePaddedEX: 0,
  handlePaddedEY: 0,
  handlePaddedEHeight: 0,
  handlePaddedEWidth: 0,

  handleSX: 0,
  handleSY: 0,
  handleSHeight: 0,
  handleSWidth: 0,
  handlePaddedSX: 0,
  handlePaddedSY: 0,
  handlePaddedSHeight: 0,
  handlePaddedSWidth: 0,

  handleNX: 0,
  handleNY: 0,
  handleNHeight: 0,
  handleNWidth: 0,
  handlePaddedNX: 0,
  handlePaddedNY: 0,
  handlePaddedNHeight: 0,
  handlePaddedNWidth: 0,

  handleInnerX: 0,
  handleInnerY: 0,
  handleInnerHeight: 0,
  handleInnerWidth: 0,
  handlePaddedInnerX: 0,
  handlePaddedInnerY: 0,
  handlePaddedInnerHeight: 0,
  handlePaddedInnerWidth: 0,

  handleDragShieldX: 0,
  handleDragShieldY: 0,
  handleDragShieldHeight: 0,
  handleDragShieldWidth: 0
};

export function calculateLocations(
  containerLocation: TRect | null
): TOverlayLocations {
  if (!containerLocation) return defaultLocations;

  return {
    x: containerLocation.x,
    y: containerLocation.y,
    height: containerLocation.height,
    width: containerLocation.width,

    frameLeftX: containerLocation.x - FRAME_WIDTH,
    frameLeftY: containerLocation.y - FRAME_WIDTH,
    frameLeftHeight: containerLocation.height + FRAME_WIDTH * 2,
    frameLeftWidth: 2,

    frameRightX: containerLocation.x + containerLocation.width,
    frameRightY: containerLocation.y - FRAME_WIDTH,
    frameRightHeight: containerLocation.height + FRAME_WIDTH * 2,
    frameRightWidth: 2,

    frameTopX: containerLocation.x - FRAME_WIDTH,
    frameTopY: containerLocation.y - FRAME_WIDTH,
    frameTopHeight: 2,
    frameTopWidth: containerLocation.width + FRAME_WIDTH * 2,

    frameBottomX: containerLocation.x - FRAME_WIDTH,
    frameBottomY: containerLocation.y + containerLocation.height,
    frameBottomHeight: 2,
    frameBottomWidth: containerLocation.width + FRAME_WIDTH * 2,

    handleNwX: OUTER_HANDLE_PADDING,
    handleNwY: OUTER_HANDLE_PADDING,
    handleNwHeight: OUTER_HANDLE_HEIGHT,
    handleNwWidth: OUTER_HANDLE_WIDTH,
    handlePaddedNwX: calculators.handlePaddedX(
      calculators.handleNwX(containerLocation),
      OUTER_HANDLE_PADDING
    ),
    handlePaddedNwY: calculators.handlePaddedY(
      calculators.handleNwY(containerLocation),
      OUTER_HANDLE_PADDING
    ),
    handlePaddedNwHeight: calculators.handlePaddedHeight(
      OUTER_HANDLE_HEIGHT,
      OUTER_HANDLE_PADDING
    ),
    handlePaddedNwWidth: calculators.handlePaddedWidth(
      OUTER_HANDLE_WIDTH,
      OUTER_HANDLE_PADDING
    ),

    handleSwX: OUTER_HANDLE_PADDING,
    handleSwY: OUTER_HANDLE_PADDING,
    handleSwHeight: OUTER_HANDLE_HEIGHT,
    handleSwWidth: OUTER_HANDLE_WIDTH,
    handlePaddedSwX: calculators.handlePaddedX(
      calculators.handleSwX(containerLocation),
      OUTER_HANDLE_PADDING
    ),
    handlePaddedSwY: calculators.handlePaddedY(
      calculators.handleSwY(containerLocation),
      OUTER_HANDLE_PADDING
    ),
    handlePaddedSwHeight: calculators.handlePaddedHeight(
      OUTER_HANDLE_HEIGHT,
      OUTER_HANDLE_PADDING
    ),
    handlePaddedSwWidth: calculators.handlePaddedWidth(
      OUTER_HANDLE_WIDTH,
      OUTER_HANDLE_PADDING
    ),

    handleWX: OUTER_HANDLE_PADDING,
    handleWY: OUTER_HANDLE_PADDING,
    handleWHeight: OUTER_HANDLE_HEIGHT,
    handleWWidth: OUTER_HANDLE_WIDTH,
    handlePaddedWX: calculators.handlePaddedX(
      calculators.handleWX(containerLocation),
      OUTER_HANDLE_PADDING
    ),
    handlePaddedWY: calculators.handlePaddedY(
      calculators.handleWY(containerLocation),
      OUTER_HANDLE_PADDING
    ),
    handlePaddedWHeight: calculators.handlePaddedHeight(
      OUTER_HANDLE_HEIGHT,
      OUTER_HANDLE_PADDING
    ),
    handlePaddedWWidth: calculators.handlePaddedWidth(
      OUTER_HANDLE_WIDTH,
      OUTER_HANDLE_PADDING
    ),

    handleNeX: OUTER_HANDLE_PADDING,
    handleNeY: OUTER_HANDLE_PADDING,
    handleNeHeight: OUTER_HANDLE_HEIGHT,
    handleNeWidth: OUTER_HANDLE_WIDTH,
    handlePaddedNeX: calculators.handlePaddedX(
      calculators.handleNeX(containerLocation),
      OUTER_HANDLE_PADDING
    ),
    handlePaddedNeY: calculators.handlePaddedY(
      calculators.handleNeY(containerLocation),
      OUTER_HANDLE_PADDING
    ),
    handlePaddedNeHeight: calculators.handlePaddedHeight(
      OUTER_HANDLE_HEIGHT,
      OUTER_HANDLE_PADDING
    ),
    handlePaddedNeWidth: calculators.handlePaddedWidth(
      OUTER_HANDLE_WIDTH,
      OUTER_HANDLE_PADDING
    ),

    handleSeX: OUTER_HANDLE_PADDING,
    handleSeY: OUTER_HANDLE_PADDING,
    handleSeHeight: OUTER_HANDLE_HEIGHT,
    handleSeWidth: OUTER_HANDLE_WIDTH,
    handlePaddedSeX: calculators.handlePaddedX(
      calculators.handleSeX(containerLocation),
      OUTER_HANDLE_PADDING
    ),
    handlePaddedSeY: calculators.handlePaddedY(
      calculators.handleSeY(containerLocation),
      OUTER_HANDLE_PADDING
    ),
    handlePaddedSeHeight: calculators.handlePaddedHeight(
      OUTER_HANDLE_HEIGHT,
      OUTER_HANDLE_PADDING
    ),
    handlePaddedSeWidth: calculators.handlePaddedWidth(
      OUTER_HANDLE_WIDTH,
      OUTER_HANDLE_PADDING
    ),

    handleEX: OUTER_HANDLE_PADDING,
    handleEY: OUTER_HANDLE_PADDING,
    handleEHeight: OUTER_HANDLE_HEIGHT,
    handleEWidth: OUTER_HANDLE_WIDTH,
    handlePaddedEX: calculators.handlePaddedX(
      calculators.handleEX(containerLocation),
      OUTER_HANDLE_PADDING
    ),
    handlePaddedEY: calculators.handlePaddedY(
      calculators.handleEY(containerLocation),
      OUTER_HANDLE_PADDING
    ),
    handlePaddedEHeight: calculators.handlePaddedHeight(
      OUTER_HANDLE_HEIGHT,
      OUTER_HANDLE_PADDING
    ),
    handlePaddedEWidth: calculators.handlePaddedWidth(
      OUTER_HANDLE_WIDTH,
      OUTER_HANDLE_PADDING
    ),

    handleSX: OUTER_HANDLE_PADDING,
    handleSY: OUTER_HANDLE_PADDING,
    handleSHeight: OUTER_HANDLE_HEIGHT,
    handleSWidth: OUTER_HANDLE_WIDTH,
    handlePaddedSX: calculators.handlePaddedX(
      calculators.handleSX(containerLocation),
      OUTER_HANDLE_PADDING
    ),
    handlePaddedSY: calculators.handlePaddedY(
      calculators.handleSY(containerLocation),
      OUTER_HANDLE_PADDING
    ),
    handlePaddedSHeight: calculators.handlePaddedHeight(
      OUTER_HANDLE_HEIGHT,
      OUTER_HANDLE_PADDING
    ),
    handlePaddedSWidth: calculators.handlePaddedWidth(
      OUTER_HANDLE_WIDTH,
      OUTER_HANDLE_PADDING
    ),

    handleNX: OUTER_HANDLE_PADDING,
    handleNY: OUTER_HANDLE_PADDING,
    handleNHeight: OUTER_HANDLE_HEIGHT,
    handleNWidth: OUTER_HANDLE_WIDTH,
    handlePaddedNX: calculators.handlePaddedX(
      calculators.handleNX(containerLocation),
      OUTER_HANDLE_PADDING
    ),
    handlePaddedNY: calculators.handlePaddedY(
      calculators.handleNY(containerLocation),
      OUTER_HANDLE_PADDING
    ),
    handlePaddedNHeight: calculators.handlePaddedHeight(
      OUTER_HANDLE_HEIGHT,
      OUTER_HANDLE_PADDING
    ),
    handlePaddedNWidth: calculators.handlePaddedWidth(
      OUTER_HANDLE_WIDTH,
      OUTER_HANDLE_PADDING
    ),

    handleInnerX: INNER_HANDLE_PADDING,
    handleInnerY: INNER_HANDLE_PADDING,
    handleInnerHeight: INNER_HANDLE_HEIGHT,
    handleInnerWidth: INNER_HANDLE_WIDTH,
    handlePaddedInnerX: calculators.handlePaddedX(
      calculators.handleInnerX(containerLocation),
      INNER_HANDLE_PADDING
    ),
    handlePaddedInnerY: calculators.handlePaddedY(
      calculators.handleInnerY(containerLocation),
      INNER_HANDLE_PADDING
    ),
    handlePaddedInnerHeight: INNER_HANDLE_HEIGHT,
    handlePaddedInnerWidth: INNER_HANDLE_WIDTH,

    handleDragShieldX: containerLocation.x,
    handleDragShieldY: containerLocation.y,
    handleDragShieldHeight: containerLocation.height,
    handleDragShieldWidth: containerLocation.width
  };
}
